export const VIEWS = {
    SETUPS_OVERVIEW: 'setupsOverview',
    EA_OVERVIEW: 'emissionAllocationOverview',
};